export default function ({ initValue, options }) {
    return {
        options,
        initValue,
        selectedOption: {
            label: '',
            value: ''
        },

        init() {
            const searchParams = new URLSearchParams(window.location.search);

            let selectedValue = '';

            if (searchParams.has('product_list_order')) {
                selectedValue = searchParams.get('product_list_order');

                if (searchParams.has('product_list_dir')) {
                    selectedValue +=
                        '__' + searchParams.get('product_list_dir');
                }
            } else {
                selectedValue = this.initValue;
            }

            this.selectedOption = this.options.find(
                (option) => option.value === selectedValue
            ) || { label: '', value: '' }; // fallback, by nie było undefined

            this.setupWatchers();
        },

        setupWatchers() {
            this.$watch('selectedOption', () => {
                if (this.selectedOption?.value) {
                    this.insertParam(this.selectedOption.value);
                }
            });
        },

        setOption(option) {
            if (option.value === this.selectedOption.value) return;
            this.selectedOption = option;
        },

        insertParam(options) {
            const selectData = {};
            const optionValueParams = options.split('__');

            selectData['product_list_order'] = optionValueParams[0];

            if (optionValueParams.length === 2) {
                selectData['product_list_dir'] = optionValueParams[1];
            }

            const kvp = document.location.search
                .substr(1)
                .split('&')
                .filter(Boolean);

            const paramsToUpdate = ['product_list_order', 'product_list_dir'];
            const updatedKvp = kvp.filter((param) => {
                return !paramsToUpdate.some((key) =>
                    param.startsWith(key + '=')
                );
            });

            updatedKvp.push(
                `product_list_order=${encodeURIComponent(
                    selectData['product_list_order']
                )}`
            );

            if (selectData['product_list_dir']) {
                updatedKvp.push(
                    `product_list_dir=${encodeURIComponent(
                        selectData['product_list_dir']
                    )}`
                );
            }

            const newSearch = '?' + updatedKvp.join('&');

            document.location.search = newSearch;
        }
    };
}
